import moment from 'moment';

/**
 * A selectable reporting month.
 *
 * `id` is the API/period form (`YYYY-MM`); `name` is what the picker shows.
 *
 * This lived in `pages/reports-old.tsx` — a page that was dropped from the
 * router but could not be deleted, because `company_report` and
 * `product-report` still imported these two from it. A shared helper parked in
 * a dead page keeps the dead page alive and hides it from anyone auditing what
 * is still in use.
 */
export type Period = {
    id: string;
    name: string;
};

/** The last 12 months, newest first. */
export function generatePeriods(): Period[] {
    const periods: Period[] = [];

    for (let i = 0; i < 12; i++) {
        const date = moment().subtract(i, 'months');
        periods.push({
            id: date.format('YYYY-MM'),
            name: date.format('MM-YYYY'),
        });
    }

    return periods;
}
